import React from "react";
// import classNames from "classnames";
import { Divider, Text, ButtonAlt } from "@atoms";
import { CardExpanded } from "@molecules";
// import brand from "@utils/brand";

// import useLgcaDefaultsData from "@staticQueries/lgca/DefaultsQuery";
// import useLakotaDefaultsData from "@staticQueries/lakota/DefaultsQuery";
// import useLgcaAcDefaultsData from "@staticQueries/lgcaAc/DefaultsQuery";
// import useLakotaAcDefaultsData from "@staticQueries/lakotaAc/DefaultsQuery";
// import useRomeroDefaultsData from "@staticQueries/romero/DefaultsQuery";

const Sidebar = ({
  actions,
  links,
  hideDefaultActions,
  hideDefaultLinks,
  defaults,
  hideDivider,
}) => {
  const actionUids = actions?.map(a => a.uid) || [];
  const linkUids = links?.map(l => l.url) || [];

  const { actions: defaultActions, links: defaultLinks } =
    defaults?.sidebar || {};

  let sidebarActions = actions || [];
  let sidebarLinks = links || [];

  // include default actions
  if (!hideDefaultActions) {
    sidebarActions = [
      ...sidebarActions,
      ...(defaultActions?.filter(a => !actionUids.includes(a.uid)) || []),
    ];
  }

  // include default links
  if (!hideDefaultLinks) {
    sidebarLinks = [
      ...sidebarLinks,
      ...(defaultLinks?.filter(l => !linkUids.includes(l.url)) || []),
    ];
  }

  return (
    <>
      {!hideDivider && <Divider />}
      <div className="sticky top-0 pt-px">
        {/* actions */}
        <div className="mb-12 mt-6">
          {!!sidebarActions?.length && <Text variant="h4">Take Action</Text>}
          {!!sidebarActions?.length &&
            sidebarActions.map(a => (
              <div key={a.uid} className="my-3 text-left">
                <CardExpanded
                  image={a?.metaImage || a?.meta?.metaImage}
                  heading={a.title}
                  cta={a.alternateCTA || "Take Action"}
                  url={a.url}
                />
              </div>
            ))}
        </div>
        {/* links */}
        <div className="my-12">
          {!!sidebarLinks?.length &&
            sidebarLinks.map(l => (
              <div key={l.uid} className="my-6 text-left">
                <ButtonAlt to={l.url}>{l.text}</ButtonAlt>
              </div>
            ))}
        </div>
        <Divider />
      </div>
    </>
  );
};

export default Sidebar;
